var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body"},[_c('div',{staticClass:"detay"},[_c('div',{staticClass:"sayfahead tek"},[_c('h1',[_vm._v("Satış ve Pazarlama Pörtföy Takip")]),_vm._v(" "),_c('el-button',{staticClass:"YeniBtn",attrs:{"type":"info","size":"small"},on:{"click":function($event){_vm.YeniUrunModal=true}}},[_vm._v("\n        Yeni Görüşme\n      ")])],1),_vm._v(" "),_c('div',{staticClass:"icerik"},[_vm._v("\n      Yapım Aşamasında\n    ")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3f972c25","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Pazarlama/Index.vue
// module id = 1178
// module chunks = 0